import "./color.scss";

import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="pie-chart-colors-3fa">{colorsTileConfig?.render()}</div>,
});
